import axios from "axios";

const Url = process.env.REACT_APP_URl;

export const DeleteNotifications = async (id: any) => {
  const response = await axios.delete(Url + "/notifications/" + id, {
    headers : {   
      "Authorization": "Bearer " + localStorage.getItem("usertoken")
    }
  })
  return response.data;
}

export const GetNotifications = async () => {
  const response = await axios.get(Url + "/notifications", {
    headers : {   
      "Authorization": "Bearer " + localStorage.getItem("usertoken")
    }
  })
  return response.data;
}
